import React, { useContext } from 'react';
import { useTheme } from '@emotion/react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { ThemeContext } from '../theme';
import { getDateString } from '../utils';

const Toast = (props) => {
  const context = useContext(ThemeContext);
  const theme = useTheme();
  let toast;
  if (theme && theme.toast) {
    toast = theme.toast;
  } else {
    toast = context.theme.toast;
  }
  const {
    color,
    background,
    borderColor,
    headerFontSize,
    headerFontWeight,
    borderRadius,
    closeBtnHoverColor
  } = toast;

  const styles = StyleSheet.create({
    toast: {
      position: 'fixed',
      right: '4px',
      border: `0.5px solid ${borderColor}`,
      width: '304px',
      boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.5)',
      font: '12px Lato',
      zIndex: '15000',
      transition: '0.3s'
    },
    header: {
      height: '40px',
      display: 'flex',
      flexFlow: 'row nowrap',
      fontWeight: 'bold',
      borderBottom: `1px solid ${borderColor}`
    },
    headerIcon: {
      height: '40px',
      width: '40px',
      minWidth: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '24px'
    },
    headerText: {
      display: 'flex',
      justifyContent: 'left',
      alignItems: 'center',
      width: '100%',
      paddingLeft: '4px'
    },
    closeBtn: {
      width: '40px',
      height: '40px',
      minWidth: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '16px',
      ':hover': {
        color: closeBtnHoverColor
      }
    },
    toastBody: {
      padding: '8px'
    },
    footer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left',
      height: '40px',
      paddingLeft: '8px'
    }
  });

  return (
    <div
      className={css(styles.toast)}
      style={{
        bottom: `${props.bottom}px`,
        top: `${props.top}px`,
        background: background,
        color: color,
        border: `0.5px solid ${borderColor}`,
        borderRadius
      }}
    >
      {!props.isCustomTemplate
        ? <React.Fragment>
            {/* Toast Header */}
            <div
              className={css(styles.header)}
              style={{
                color: props.headerTextColor,
                fontSize: headerFontSize,
                fontWeight: headerFontWeight
              }}
            >
              <div className={css(styles.headerIcon)}>
                {/* <img src={props.headerIcon} /> */}
                <i className={`${props.headerIcon}`} />
              </div>

              <div className={css(styles.headerText)}>
                {props.headerText}
              </div>

              <div
                className={css(styles.closeBtn)}
                onClick={() => {
                  props.onDismiss(props.id);
                }}
              >
                <i className="fa fa-times" />
              </div>
            </div>

            {/* Toast Body */}
            <div
              className={css(styles.toastBody)}
              style={{
                color: color
              }}
            >
              {props.bodyText}
            </div>

            {/* Toast Footer */}
            {props.showFooter
              ? <div
                  className={css(styles.footer)}
                  style={{
                    background: background
                  }}
                >
                  {getDateString()}
                </div>
              : null
            }
          </React.Fragment>
        : props.children
      }
    </div>
  );
};

export { Toast };
